export const GMarker = {
	name: 'GMarker',
	props: {
		position: null,
		icon: null,
	},
	render: (h) => {
		return null;
	},
	mounted() {
		new this.$parent.loader.maps.Marker({
			map: this.$parent.map,
			position: this.position,
			icon: this.icon,
		});

		this.$parent.$emit("add-bounds", this.position);
	},
}
